export const userGroup = {
    text:{
        optionGestion: 'Gestión de grupos',
        generateDetailInform: 'Generando descarga del documento',
        'countUsersSelected_one': '{{count}} usuario seleccionado',
        'countUsersSelected_other': '{{count}} usuarios seleccionados',
        whenEnteringMoreThanOneEmailAddressSeparatedComma: 'Al momento de ingresar más de un correo se debe separar por una coma.'
    },
    'titles':{
        groupGestion: 'Gestión de grupos',
        groupName: 'Nombre del grupo',
        userList: 'Lista de usuarios',
        userSelected: 'Usuarios seleccionados',
        externalUser: 'Usuarios externos',
        permissionAsignement: 'Asignación de permisos',
        searchUsers: 'Búsqueda usuarios',
        groupAcces: 'Acceso al grupo',
        sellectUsersToAddPermission: 'Seleccione los usuarios a los cuales les dará acceso al grupo',
        form :{
            1: 'Creación del grupo',
            2: 'Detalles del grupo',
            3: 'Edición del grupo',
        }
    },
    tabs:{
        internalUser: 'Usuario interno',
        externalUser: 'Usuario externo'
    },
    filter:{
        search: 'Buscar nombre del grupo'
    },
    columns: {
        groupName: 'Nombre del grupo',
        creatorUser: 'Usuario creador',
        numberOfInternalUsers: 'Cantidad de usuarios internos',
        numberOfExternalUsers: 'Cantidad de usuarios externos',
        createDate: 'Fecha de creación',
        actions: 'Acciones',
        userName: 'Nombre del usuario',
        role: 'Rol',
        userType: 'Tipo de usuario',
        area: 'Área',
        department: 'Departamento'
    },
    inputs:{
        title:{
            nameGroup: 'Nombre del grupo'
        },
        error:{
            nameRequired: 'El campo nombre del grupo es requerido',
            nameMinLength: 'El campo debe contener un minimo de {{min}} caracteres'
        }
    },
    modal:{
        titles:{
            deleteAll:'¿Estás seguro que desea eliminar los usuarios seleccionados?',
            areYouSureAsignThisPermission: '¿Estás seguro que desea asignar estos usuarios al grupo?',
            backToList: '¿Estás seguro que quieres regresar al listado?',
            backToDetail: '¿Estás seguro que quieres regresar al detalle del grupo?',
            'areYouSureWantCreateThisGroup':'¿Estás seguro que desea crear este grupo?',
            'areYouSureWantEditThisGroup':'¿Estás seguro que desea editar este grupo?',
            confirmation: 'Confirmación',
            'areYouSureWantDeleteAllGroupsSelected_one': '¿Está seguro que desea eliminar este grupo?',
            'areYouSureWantDeleteAllGroupsSelected_other': '¿Estás seguro que deseas eliminar los grupos seleccionados?',
            'areYouSureWantDeleteThisGroupSelected': '¿Estás seguro que deseas eliminar este grupo?',
        },
        description: {
            deleteAll:'Al eliminar los usuarios, se les removerá el acceso al grupo seleccionado',
            backToList: 'Al regresar al listado, se perderan los cambios realizados',
            backToDetail: 'Al regresar al detalle, se perderan los cambios realizados',
            'areYouSureWantDeleteAllGroupsSelected_one': 'Al eliminar un grupo, se borrará de tu lista y debes realizar nuevamente su configuración.',
            'areYouSureWantDeleteAllGroupsSelected_other': 'Al eliminar los grupos, se borrarán de tu lista y debes realizar nuevamente su configuración.',
            'areYouSureWantDeleteThisGroupSelected': 'Al eliminar un grupo, se borrará de tu lista y debes realizar nuevamente su configuración.',
        }
    },
    snackbar: {
        selectAtLeastOneGroup: 'Debes seleccionar al menos un grupo para realizar esta acción',
        create:{
            success:'Creaste un grupo de manera exitosa',
            error: 'Ocurrió un error al intentar crear el grupo.'
        },
        edit:{
            success:'Editaste el grupo de manera exitosa',
            error: 'Ocurrió un error al intentar editar el grupo.'
        },
        delete:{
            success:'Se eliminó el grupo de manera exitosa',
            error: 'Ocurrió un error al intentar eliminar el grupo.'
        },
        masive:{
            success:'Los grupos seleccionados se eliminaron correctamente.',
            error: 'Ocurrió un error al intentar eliminar los grupos seleccionados.'
        },
        updatePermision: {
            success:'Los permisos se actualizaron exitosamente.',
            error: 'Ocurrió un error al intentar actualizar los permisos.'
        }
    }
  }